import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import s from "./styles.module.css";

const ImageSlider = ({ images }) => {
    const handleStopPropagation = (e) => {
        if (e.target.classList.contains("swiper-button-next") || e.target.classList.contains("swiper-button-prev")) {
            e.stopPropagation();
        }
    };

    return (
        <div onClick={handleStopPropagation}>
            <Swiper
                modules={[Navigation]}
                navigation={images.length > 1} // Скрыть, если 1 фото
                spaceBetween={10}
                slidesPerView={1}
                loop={images.length > 1} // Луп тоже отключаем, если 1 фото
                className={s.sliderContainer}
            >
                {images.map((img, index) => (
                    <SwiperSlide key={index}>
                        <img
                            src={img}
                            alt={`Slide ${index}`}
                            style={{ width: "100%", height: "250px", objectFit: "cover" }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ImageSlider;
